import { Text, BalanceText, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../../../components/TableContent';
import { mapCaptions } from '../../../../../../utils';

import { IsClosedLayoutResponsiveProps } from '.';

export const Desktop: React.FC<IsClosedLayoutResponsiveProps> = ({
  data,
  handleUpdateBalance,
  isLoadingBalance,
}) => {
  return (
    <HStack p={Spacing['inline.xxs']} justifyContent="space-between">
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="bold">Nome</Text>
        <Text>{data?.name}</Text>
        <TableContentItemCaptions icons={mapCaptions(data ?? {})} forceDesktop />
      </VStack>
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="bold">CPF/CNPJ</Text>
        <Text>{data?.cpfCnpjFormatted}</Text>
      </VStack>
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="bold">Conta</Text>
        <Text>{data?.accountNumber}</Text>
      </VStack>
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="bold">Suitability</Text>
        <TableContentItemBadge>{data?.suitabilityProfileName!}</TableContentItemBadge>
      </VStack>
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="bold">Situação cadastral</Text>
        <Text>{data?.registrationStatusName}</Text>
      </VStack>
      <VStack space={Spacing['inline.quarck']} alignItems="flex-end">
        <Text variant="bold">Saldo disponível</Text>
        <BalanceText
          balance={data?.availableBalance}
          lastUpdatedAt={new Date()}
          isUpdating={isLoadingBalance}
          textAlign="flex-end"
          hasUpdateButton
          onUpdateButtonPress={handleUpdateBalance}
          positiveBalanceColor="neutral.black"
          negativeBalanceColor="feedback.error.default"
        />
      </VStack>
    </HStack>
  );
};
